import { Component, type ErrorInfo, type ReactNode } from 'react'
import { Link } from 'react-router-dom'

import { NODE_ENV, PRODUCTION } from '@/constants'

export class ErrorBoundary extends Component<
  { children: ReactNode },
  { hasError: boolean }
> {
  constructor(props: { children: ReactNode }) {
    super(props)
    this.state = {
      hasError: false,
    }

    this.handleResetError = this.handleResetError.bind(this)
  }

  public static getDerivedStateFromError(_: Error): { hasError: boolean } {
    return { hasError: true }
  }

  componentDidCatch = (error: Error, errorInfo: ErrorInfo): void => {
    console.error('Uncaught error', error)
  }

  private readonly handleResetError = (): void => {
    this.setState({ hasError: false })
  }

  render = (): React.ReactNode => {
    if (this.state.hasError && NODE_ENV === PRODUCTION) {
      return (
        <>
          <h2>Something went wrong.</h2>
          <Link to='/' onClick={this.handleResetError}>
            Return to home
          </Link>
        </>
      )
    }

    return this.props.children
  }
}
